import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    '[ONE MAILLOT] Supabase config missing!\n' +
    'Add to .env (local) or Vercel Environment Variables:\n' +
    '  REACT_APP_SUPABASE_URL=https://your-project.supabase.co\n' +
    '  REACT_APP_SUPABASE_ANON_KEY=your-anon-key'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
